import { useState, useEffect } from 'react';
import Select from 'react-select';
import { URL_APPEND, reactSelectStyles } from '@general/constants';
import axios from "axios";

const SelectBill = ({ onChange, value }) => {
    const [bills, setBills] = useState([]);

    let billUrl = URL_APPEND + '/api/tracker/bills', trackerUrl = `${URL_APPEND}/api/tracker/`;

    useEffect(() => {

        axios.get(billUrl)
            .then(res => {
                setBills(res.data.map(b => ({
                    value: b.id,
                    label: b.title
                })))
            })
            .catch(err => console.log(err));
    }, [])

    return <Select
        menuPortalTarget={document.querySelector('body')}
        placeholder='Select Bill...'
        options={bills}
        onChange={onChange}
        styles={reactSelectStyles}
        value={value}
    >
    </Select>
}

export default SelectBill;